import React from 'react';
import { Route } from 'react-router-dom';
import loadable from '@loadable/component';
import { Loadable } from 'components/Loadable';
import constants from 'Constants';
import * as paths from 'Paths';



const WorkflowPlaybooksRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/control/workflow-playbooks" */
    'routes/Control/Workflows/PlaybooksRoute'
  )
));

const UpdateWorkflowRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/control/update-workflow" */
    'routes/Workflows/UpdateWorkflowRoute'
  )
));



const getControWorkflowsRoutes = () => {
  return [
    {path: paths.getPathControlWorkflowPlaybooks(), component: WorkflowPlaybooksRoute},
    {path: paths.getPathControlAddWorkflowPlaybook(), render: (props) => <UpdateWorkflowRoute {...props} isPlaybook={true} />},
    {path: paths.getPathControlEditWorkflowPlaybook(":playbookId"), render: (props) => <UpdateWorkflowRoute {...props} isPlaybook={true} />},
    {path: paths.getPathControlReplicateWorkflowPlaybook(":playbookId"), render: (props) => <UpdateWorkflowRoute {...props} isPlaybook={true} isReplicate={true} />},
  ]
}



export { getControWorkflowsRoutes };
